const mutations = {
  setServiceName(state, serviceName) {
    state.serviceName = serviceName;
  },
  setPermission(state, payload) {
    state.permission = payload;
  },
  setUserName(state, userName) {
    state.userProfile.userName = userName;
  },
  setRoles(state, roles) {
    state.userProfile.roles = roles;
  },
  setUserEmail(state, userEmail) {
    state.userEmail = userEmail;
  },
  selectService(state, serviceName) {
    state.serviceName = serviceName;
  },
  setAdditionalProfileProperties(state, additionalProperties) {
    const profileTypeName = additionalProperties.preferred_username.split(
      "@"
    )[1];
    const sgIDType = () => {
      if (profileTypeName === "singpass") {
        const identityFirstCharacter = additionalProperties.identity_number[0].toUpperCase();
        if (identityFirstCharacter == "S" || identityFirstCharacter == "T") {
          //NRIC
          return 2;
        } else {
          // FIN
          return 3;
        }
      } else {
        //UEN
        return 1;
      }
    };

    state.userProfile.sgID = additionalProperties.identity_number;
    state.userProfile.sgIDType = sgIDType();
    state.userProfile.profileType = profileTypeName === "singpass" ? 2 : 1;
    state.userProfile.userId = additionalProperties.sub;

    if (additionalProperties.nric)
      state.userProfile.nric = additionalProperties.nric;
  },

  setHasProfileTo(state, hasProfile) {
    state.hasProfile = hasProfile;
  },

  setAdditionalProfileInfo(state, additionalProfileInfo) {
    window.Vue.prototype.$set(
      state.userProfile,
      "additionalProfileInfo",
      additionalProfileInfo
    );
    // state.userProfile.additionalProfileInfo = { ...additionalProfileInfo };
  },

  setIsValidated(state, isValidated) {
    window.Vue.prototype.$set(state.userProfile, "isValidated", isValidated);
  },

  setCanImpersonate(state, canImpersonate) {
    window.Vue.prototype.$set(
      state.userProfile,
      "canImpersonate",
      canImpersonate
    );
  },

  setIsImpersonating(state, isImpersonating) {
    state.isImpersonating = isImpersonating;
  }
};

export default mutations;
